"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceCreateDialog = ServiceCreateDialog;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var charge_1 = require("../../../features/apis/charge");
var service_1 = require("../../../features/apis/service");
var hooks_1 = require("../../../store/hooks");
var build_service_payload_1 = require("../services/build-service-payload");
var charge_form_1 = require("../services/charge-form");
var service_form_1 = require("../services/service-form");
/*
 * MC&LCC-3.2 — creating a service without leaving the configuration screen.
 *
 * Erik: "Add a button in this section to create a service (this must be a pop-up with all the data
 * fields and functionality of creating a service, but add the ability to add charges at the bottom of
 * the pop-up. This is to assist the user to create additional services, or create the services if
 * they have not been created."
 *
 * "All the data fields and functionality" is the existing ServiceForm — 1,800 lines of type-dependent
 * fields — so this wraps it rather than reproducing it. The payload assembly is shared with the
 * services screen through `buildCreateServicePayload` for the same reason.
 *
 * Charges come second because they cannot come first: a charge belongs to a service id, which does
 * not exist until the service is created. So the dialog has two steps, and the second is optional —
 * the user can create the service and close, and add charges later on the services screen.
 */
function ServiceCreateDialog(props) {
    var _this = this;
    var isOpen = props.isOpen, clientId = props.clientId, buildingId = props.buildingId, onClose = props.onClose, onCreated = props.onCreated;
    var userId = (0, hooks_1.useAppSelector)(function (state) { return state.auth; }).userId;
    var createService = (0, service_1.useCreateServiceMutation)()[0];
    var createCharge = (0, charge_1.useCreateChargeMutation)()[0];
    /** Null until the service exists; after that, charges can be added against it. */
    var _a = (0, react_3.useState)(null), created = _a[0], setCreated = _a[1];
    var _b = (0, react_3.useState)(0), chargesAdded = _b[0], setChargesAdded = _b[1];
    var _c = (0, react_3.useState)(false), addingCharge = _c[0], setAddingCharge = _c[1];
    var reset = function () {
        setCreated(null);
        setChargesAdded(0);
        setAddingCharge(false);
    };
    var handleServiceSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var response, serviceId, error_1, message;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, createService((0, build_service_payload_1.buildCreateServicePayload)(data, clientId, userId)).unwrap()];
                case 1:
                    response = _d.sent();
                    if (!response.success) {
                        (0, react_1.addToast)({ title: "Create failed", description: response.message || "Could not create service.", color: "danger" });
                        return [2 /*return*/, false];
                    }
                    serviceId = String((_b = (_a = response.content) === null || _a === void 0 ? void 0 : _a._id) !== null && _b !== void 0 ? _b : "");
                    setCreated({ serviceId: serviceId, name: data.name });
                    (0, react_1.addToast)({ title: "Service created", description: "\"".concat(data.name, "\" is ready. Add its charges below, or close."), color: "success" });
                    // The section behind reloads now, so the new service is pickable even if charges are skipped.
                    onCreated();
                    return [2 /*return*/, true];
                case 2:
                    error_1 = _d.sent();
                    message = ((_c = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _c === void 0 ? void 0 : _c.message) || "An error occurred while creating the service.";
                    (0, react_1.addToast)({ title: "Create failed", description: message, color: "danger" });
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleChargeSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_2, message;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!created)
                        return [2 /*return*/, false];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createCharge(__assign(__assign({}, data), { clientId: clientId, serviceId: created.serviceId, createdBy: userId })).unwrap()];
                case 2:
                    response = _b.sent();
                    if (!response.success) {
                        (0, react_1.addToast)({ title: "Charge not added", description: response.message || "Could not add the charge.", color: "danger" });
                        return [2 /*return*/, false];
                    }
                    setChargesAdded(function (n) { return n + 1; });
                    setAddingCharge(false);
                    (0, react_1.addToast)({ title: "Charge added", description: "Added to \"".concat(created.name, "\"."), color: "success" });
                    return [2 /*return*/, true];
                case 3:
                    error_2 = _b.sent();
                    message = ((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.data) === null || _a === void 0 ? void 0 : _a.message) || "An error occurred while adding the charge.";
                    (0, react_1.addToast)({ title: "Charge not added", description: message, color: "danger" });
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, size: "4xl", scrollBehavior: "inside", 
        // Overlays in this app are invisible without this — framer-motion v12 against HeroUI's animation.
        disableAnimation: true, 
        // The globally mounted dialogs sit at z-[60], so anything opened over them has to clear it.
        classNames: { wrapper: "z-[70]", backdrop: "z-[69]" }, onClose: function () {
            reset();
            onClose();
        }, children: (0, jsx_runtime_1.jsxs)(react_1.ModalContent, { children: [(0, jsx_runtime_1.jsxs)(react_1.ModalHeader, { className: "flex flex-col gap-0.5", children: [(0, jsx_runtime_1.jsx)("span", { children: created ? "Charges for \"".concat(created.name, "\"") : "Create a service" }), (0, jsx_runtime_1.jsx)("span", { className: "text-[12px] font-normal text-gray-500", children: created
                                ? "Optional — the service is already saved and can be assigned to a premise."
                                : "The service will be available to assign as soon as it is saved." })] }), (0, jsx_runtime_1.jsx)(react_1.ModalBody, { className: "pb-6", children: !created ? ((0, jsx_runtime_1.jsx)(service_form_1.ServiceForm, { onSubmit: handleServiceSubmit, initialData: { buildingId: buildingId } })) : ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-3", children: [(0, jsx_runtime_1.jsx)(react_1.Alert, { color: "success", children: (0, jsx_runtime_1.jsxs)("p", { className: "text-[13px]", children: ["\"", created.name, "\" was created", chargesAdded ? " with ".concat(chargesAdded, " charge").concat(chargesAdded === 1 ? "" : "s") : "", ". You can assign it to a premise now."] }) }), addingCharge ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_1.Divider, {}), (0, jsx_runtime_1.jsx)(charge_form_1.ChargeForm, { onSubmit: handleChargeSubmit, onCancel: function () { return setAddingCharge(false); } })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-wrap items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", variant: "bordered", startContent: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:add-circle-linear" }), onPress: function () { return setAddingCharge(true); }, children: chargesAdded ? "Add another charge" : "Add a charge" }), (0, jsx_runtime_1.jsx)(react_1.Button, { size: "sm", color: "primary", onPress: function () {
                                            reset();
                                            onClose();
                                        }, children: "Done" })] }))] })) })] }) }));
}
